module.exports = __webpack_public_path__ + "static/media/training_program.537c113a.webp";